import React, { useContext, useEffect, useState, useMemo } from "react";
import MUIDataTable from "mui-datatables";
import rest from "../../rest";
import { useStylesGlobal } from "../../pages/GlobalStyle.css";
import InfosBenevole from "../infosBenevole/InfosBenevole";
import {
  Dialog,
  DialogActions,
  Button,
  TextField,
  IconButton,
  InputAdornment,
} from "@material-ui/core";
import clsx from "clsx";
import CloseIcon from "@material-ui/icons/Close";
import { useStyleLesBenevoles } from "../../pages/LesBenevoles/Lesbenevoles.css";
import AppContext from "../appContext";
import LoadingIndicator from "../../components/loadingIndicator/LoadingIndicator";
import PopperTipsBenevol from "../cards/PopperTipBenev";
import GetRandomKey from "../general/genereRandomKey";
import textLabels from "./textLabel";
import { dateToDateAge, formatTimeToDate } from "../general/formateDate";
import { useSelector } from "react-redux";

// Debut fonction
// Lors de l'utilisation du readOnly --> précisé s'il est true/false
export default function DataTable({
  filter,
  customToolbar,
  readOnly,
  valeurFiltre,
  attribut,
  nom,
}) {
  const [benevole, setBenevole] = useState([]);
  const [loading, setLoading] = useState(false);
  // Le CSS
  const classesLesBenevoles = useStyleLesBenevoles();
  const classesGlobal = useStylesGlobal();
  // Le contenu du tableau
  const [rowSelected, setRowSelected] = useState(-1);
  const [benevSelectedId, setBenevSelectedId] = useState(0);
  const [benevSelectedName, setBenevSelectedName] = useState("");
  const [benevSelectedFirstName, setBenevSelectedFirstName] = useState("");

  const [searchText, setSearchText] = useState("");

  const context = useContext(AppContext);
  const openSidebar = context.openSidebar;
  const manifParams = useSelector((state) => state.manif);

  const [searchOpen, setSearchOpen] = useState(true);

  const [sortOrder, setSortOrder] = useState({
    name: "Name",
    direction: "asc",
  });
  const getLastInscription = (data) => {
    const isWichList = manifParams?.manifParams?.InscripionWishlist;

    return data.map((item) => {
      const dernierInscription = isWichList
        ? item.link_Wishlist_Person?.reduce(
          (max, tranche) =>
            tranche.DateHeureInscription > max
              ? tranche.DateHeureInscription
              : max,
          0
        ) || null
        : item.lien_Person_PersonTranche?.reduce(
          (max, tranche) =>
            tranche.DateHeureAjout > max ? tranche.DateHeureAjout : max,
          0
        ) || null;

      return {
        ...item,
        dernier_inscription: dernierInscription, //? new Date(dernierInscription * 1000).toISOString() : null, // Convertir le timestamp en date ISO si nécessaire
      };
    });
  };

  // Valeur Requete Benevole
  useEffect(() => {
    setLoading(true);
    let params = {
      newUi: true,
      vFiltre: valeurFiltre,
      vFiltreAttribut: attribut
        ? attribut.length > 0
          ? ";" + attribut.join(";")
          : ""
        : "",
    };

    if (filter) {
      for (const key in filter) {
        if (typeof filter[key] === "object") {
          params[key] = JSON.stringify(filter[key]);
        } else {
          params[key] = filter[key];
        }
      }
    }
    // Requete avec les parametres    
    rest
      .post("/benevols/listebenevoles.json", params)
      .then(function (response) {
        setLoading(false);
        setBenevole(getLastInscription(response.data));
      })
      .catch(function (error) {
        console.log(error);
        setLoading(false);
      });
    // eslint-disable-next-line
  }, [filter, valeurFiltre, attribut]);

  useEffect(() => {
    const refreshBen = context.refreshBen;
    if (!refreshBen || refreshBen.id === 0) return;

    switch (refreshBen.type) {
      case 'delete':
        setBenevole(prevBenevoles => prevBenevoles.filter(b => b.ID !== refreshBen.id));
        break;
      case 'change':
        rest.post('/benevols/getUserForListe.json', { vIdUser: refreshBen.id })
          .then(response => {
            setBenevole(prevBenevoles => {
              const updatedBenevoles = [...prevBenevoles];
              const index = updatedBenevoles.findIndex(b => b.ID === refreshBen.id);

              if (index >= 0) {
                setBenevSelectedName(updatedBenevoles[index].Name);
                setBenevSelectedFirstName(updatedBenevoles[index].Firstname);
                updatedBenevoles[index] = getLastInscription([response.data])[0];
              }
              return updatedBenevoles;
            });
          })
          .catch(error => {
            console.log(error);
          });
        break;
      default:
        break;
    }
    // eslint-disable-next-line
  }, [context, context.refreshBen]);


  const columns = [
    {
      label: "ID",
      name: "ID",
      options: {
        download: false,
        viewColumns: false,
        filter: false,
        display: "excluded",
      },
    },
    {
      label: "Nom",
      name: "Name",
      options: {
        filter: true,
        sortThirdClickReset: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          const randKey = GetRandomKey(9);
          const row = tableMeta.rowData;
          // const person = { Person_ID: row[0], Person_Name: row[1], Person_Firstname: row[2], Person_Birth: row[3], Person_Phone_Mobile: row[4], Person_Email: row[5] }
          // person.Person_Address = row[6];
          // person.Person_Tshirt = row[7];
          return (
            <PopperTipsBenevol
              idBenevole={row[0]}
              person={null}
              text={value || ""}
              componentKey={randKey}
              showEdit={false}
            />
          );
        },
      },
    },
    {
      label: "Prénom",
      name: "Firstname",
      options: {
        filter: true,
        sortThirdClickReset: true,
      },
    },
    {
      label: "Naissance",
      name: "Birth",
      options: {
        filter: true,
        sortThirdClickReset: true,
        customBodyRender: (value) => {
          var dateFormatee = "";
          if (value !== "0000-00-00T00:00:00.000Z") {
            dateFormatee = dateToDateAge(value);
          }
          return dateFormatee;
        },
      },
    },
    {
      label: "Mobile",
      name: "Phone_Mobile",
      options: {
        filter: true,
        sortThirdClickReset: true,
      },
    },
    {
      label: "Email",
      name: "Email",
      options: {
        filter: true,
        sortThirdClickReset: true,
      },
    },
    /* {
      label: "Inscription",
      name: "person_profil",
      options: {
        filter: false,
        sortThirdClickReset: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          // Vérifiez la valeur du timestamp
          const time = value?.[0]?.profil_user?.Timestamp_creation;

          // Vérifiez si le timestamp est valide
          if (!time) {
            return "Date time invalide";
          }

          const date = new Date(time * 1000);
          if (isNaN(date.getTime())) {
            return "Date invalide";
          }

          // Formater la date
          const formattedValue = date.toLocaleDateString("fr-FR", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
          });

          return formattedValue;
        },
        sort: true,
        sortCompare:
          (order) =>
          ({ data: rowData1 }, { data: rowData2 }) => {
            const timestamp1 =
              rowData1?.[0]?.profil_user?.Timestamp_creation || 0;
            const timestamp2 =
              rowData2?.[0]?.profil_user?.Timestamp_creation || 0;
            return (timestamp1 - timestamp2) * (order === "asc" ? 1 : -1);
          },
      },
    }, */
    {
      label: "Dernière inscription (édition actuelle)",
      name: "dernier_inscription",
      options: {
        filter: true,
        sortThirdClickReset: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          if (!value) return "/";
          return formatTimeToDate(value);
        },
        sort: true,
      },
    },
    // {
    //   label: "Dernière inscription",
    //   name: "lastInscription",
    //   options: {
    //     display: false,
    //     filter: true,
    //     sortThirdClickReset: true,
    //   }
    // },
    // {
    //   label: "Dernière inscription",
    //   name: "lastInscriptionNumerique",
    //   options: {
    //     filter: false,
    //     sortThirdClickReset: true,
    //     display: valeurFiltre === "Edition",
    //     customBodyRender: (value, tableMeta, updateValue) => {
    //       return tableMeta.rowData[6]
    //     },
    //   }
    // },
    // {
    //   label: "Sexe",
    //   name: "Gender",
    //   options: {
    //     download: true,
    //     viewColumns: false,
    //     filter: false,
    //     display: 'excluded',
    //   }
    // },
    {
      label: "Adresse",
      name: "Address",
      options: {
        download: false,
        viewColumns: false,
        filter: false,
        display: "excluded",
      },
    },
    // {
    //   label: "Adresse comp.",
    //   name: "Address_2",
    //   options: {
    //     download: true,
    //     viewColumns: false,
    //     filter: false,
    //     display: 'excluded',
    //   }
    // },
    // {
    //   label: "No Postal",
    //   name: "Zip",
    //   options: {
    //     download: true,
    //     viewColumns: false,
    //     filter: false,
    //     display: 'excluded',
    //   }
    // },
    // {
    //   label: "Ville",
    //   name: "Locality",
    //   options: {
    //     download: true,
    //     viewColumns: false,
    //     filter: false,
    //     display: 'excluded',
    //   }
    // },
    // {
    //   label: "Pays",
    //   name: "Country",
    //   options: {
    //     download: true,
    //     viewColumns: false,
    //     filter: false,
    //     display: 'excluded',
    //   }
    // },
    // {
    //   label: "Tèl. privé",
    //   name: "Phone_Pers",
    //   options: {
    //     download: true,
    //     viewColumns: false,
    //     filter: false,
    //     display: 'excluded',
    //   }
    // },
    // {
    //   label: "Tèl. pro",
    //   name: "Phone_Pro",
    //   options: {
    //     download: true,
    //     viewColumns: false,
    //     filter: false,
    //     display: 'excluded',
    //   }
    // },
    {
      label: "T-Shirt",
      name: "Taille_Tshirt",
      options: {
        download: false,
        viewColumns: false,
        filter: false,
        display: "excluded",
      },
    },
    // {
    //   label: "Groupe",
    //   name: "Groupe",
    //   options: {
    //     download: true,
    //     viewColumns: false,
    //     filter: false,
    //     display: 'excluded',
    //   }
    // },
    // {
    //   label: "Points",
    //   name: "point",
    //   options: {
    //     download: true,
    //     viewColumns: false,
    //     filter: false,
    //     display: 'excluded',
    //   }
    // },
    // {
    //   label: "Nbr Heure",
    //   name: "nbHeure",
    //   options: {
    //     download: true,
    //     viewColumns: false,
    //     filter: false,
    //     display: 'excluded',
    //   }
    // },
    // {
    //   label: "Première inscription",
    //   name: "firstSubscription",
    //   options: {
    //     download: true,
    //     viewColumns: false,
    //     filter: false,
    //     display: 'excluded',
    //   }
    // },
  ];

  
  const handleClose = () => {
    setBenevSelectedId(0);
  };

  // Garder les donnes de la ligne selectionnée
  const handleLineSelection = (rowData, rowMeta) => {
    setRowSelected(rowMeta.dataIndex);
    let ben = filteredData[rowMeta.dataIndex];
    setBenevSelectedId(ben.ID);
    setBenevSelectedName(ben.Name);
    setBenevSelectedFirstName(ben.Firstname);
  };

  const options = {
    search: !searchOpen,
    searchOpen: searchOpen,
    onSearchOpen: () => setSearchOpen(true),
    onSearchClose: () => {
      setSearchText("");
      return setSearchOpen(false);
    },
    searchPlaceholder: "Rechercher...",
    customSearchRender: (searchText, handleSearch, hideSearch, options) => (
      <div style={{ marginRight: "16px" }} key={GetRandomKey(16)}>
        <TextField
          variant="outlined"
          size="small"
          fullWidth
          value={searchText}
          onChange={(e) => {
            setSearchText(e.target.value);
            handleSearch(e.target.value); // Ajout de cette ligne
          }}
          placeholder={options.searchPlaceholder}
          autoFocus
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton onClick={() => hideSearch()} size="small">
                  <CloseIcon />
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
      </div>
    ),

    filter: false,
    print: false,
    viewColumns: false,
    selectableRows: "none",
    responsive: "vertical",
    sortOrder: sortOrder,
    onColumnSortChange: (changedColumn, direction) => {
      setSortOrder({ name: changedColumn, direction: direction });
    },
    downloadOptions: { filename: "donneeBenevole.csv", separator: ";" },
    onDownload: function (buildHead, buildBody, columns, data) {
      if (
        typeof valeurFiltre !== "undefined" &&
        typeof attribut !== "undefined"
      ) {
        window.open(
          "/export/benevoles/globale?vFiltre=" +
          valeurFiltre +
          "&vFiltreAttribut=" +
          attribut.join(";")
        );
      } else {
        window.open("/export/benevoles/globale?vFiltre=mesBenevoles");
      }
      return false;
    },
    // onCellClick: () => { setLoading(true);},
    onRowClick: (a, b, c) => {
      setLoading(true);      
      handleLineSelection(a, b, c);
      setTimeout(
        () => {
          setLoading(false);
        }, 500, a, b, c);
    },
    customToolbar: customToolbar ? customToolbar : null,
    textLabels: textLabels,
    setRowProps: (row, rowIndex) => {
      return {
        className: clsx({
          [classesLesBenevoles.SelectedRow]: rowIndex === rowSelected,
        }),
      };
    },
  };

  const removeAccents = (str) => {
    return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  };

  const filteredData = useMemo(() => {
    if (!searchText) return benevole;

    const searchTerm = searchText.toLowerCase().trim();
    const normalizedSearchTerms = searchTerm
      .split(" ")
      .map((term) => removeAccents(term)); // Normalisation des termes de recherche

    const result = benevole.filter((row) => {
      // Normalisation des données pour comparaison sans tenir compte des accents
      const normalizedRowName = removeAccents(row.Name.toLowerCase());
      const normalizedRowFirstname = removeAccents(row.Firstname.toLowerCase());
      const normalizedRowEmail = removeAccents(row.Email.toLowerCase());

      const benev = normalizedSearchTerms.every((term) => {
        return (
          normalizedRowName.includes(term) ||
          normalizedRowFirstname.includes(term) ||
          normalizedRowEmail.includes(term) ||
          row.Birth.includes(term)
        );
      });
      return benev;
    });

    return result;
  }, [benevole, searchText]);

  //////////////////////////////////
  // Return
  /////////////////////////////////
  return (
    <>
      <LoadingIndicator open={loading} />
      <MUIDataTable
        title={<h1>{nom}</h1>}
        data={filteredData}
        columns={columns}
        options={options}
        className={`DataTableProperTips ${filteredData.length < 5 ? 'owerflowNone' : ''} ${openSidebar ? '' : 'noSideBar'}`}
        style={{ zIndex: 1 }}
      />
      
        <Dialog
          open={benevSelectedId > 0 }
          onClose={handleClose}
          fullWidth
          // disableBackdropClick
          scroll="body"
          style={{
            marginTop: "-1px",
            height: "calc(100% - 30px)",
            width: "calc(100% - 30px)",
            margin: "0 auto",
          }}
        >
          <InfosBenevole
            readOnly={readOnly}
            idBenevole={benevSelectedId}
            benevSelectedName={benevSelectedName}
            benevSelectedFirstName={benevSelectedFirstName}
            handleClose={handleClose}
            setRefreshBen={context.setRefreshBen}
          />
          <DialogActions>
            <Button
              variant="contained"
              onClick={handleClose}
              className={classesGlobal.buttonFermer}
            >
              Fermer
            </Button>
          </DialogActions>
        </Dialog>
      
    </>
  );
}
